import Button from '@rio-cloud/rio-uikit/Button';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import { useIntl } from 'react-intl';

import type { Document } from '#domain/Document.ts';
import type { UploadDocumentTarget } from '#features/documents/model/UploadDocumentTarget.ts';

import { DocumentUpload } from './DocumentUpload.tsx';

type CreateOrderDialogProps = {
    shown: boolean;
    onClose: () => void;
    associations: Document['associations'];
    uploadTarget: UploadDocumentTarget;
};

export const DocumentUploadDialog = ({ shown, onClose, associations, uploadTarget }: CreateOrderDialogProps) => {
    const intl = useIntl();
    const dialogTitleId = 'intl-msg:ordercom-cloud-frontend.common.upload';
    return (
        <Dialog
            show={shown}
            onClose={onClose}
            showCloseButton={false}
            bsSize='md'
            data-testid={'order-dialog-document-upload-dialog'}
            title={intl.formatMessage({
                id: dialogTitleId,
            })}
            body={<DocumentUpload onClose={onClose} associations={associations} uploadTarget={uploadTarget} />}
            headerButtons={
                <Button
                    bsStyle={Button.MUTED}
                    iconOnly
                    iconName='remove'
                    autoTrackingKey={`${dialogTitleId}.close`}
                    className='modal-header-close close'
                    onClick={onClose}
                    aria-label='dialog close button'
                />
            }
        />
    );
};
